import { RenewableSystemType as ActualRenewableSystemType } from '../enums';
import { HarmonyAddress } from '../services/harmony';
import { State } from './application/finance-application-details-model';

export enum SavingFrequency {
    Quarterly = 'Quarterly',
    Monthly = 'Monthly',
    Annually = 'Annually'
}

export interface ClientName {
    firstName: string;
    middleName?: string;
    lastName: string;
}

export interface ClientAddress {
    fullAddress: string | null;
    unitNumber: string | null;
    streetNumber: string | null;
    street: string | null;
    suburb: string | null;
    postcode: string | null;
    state: State | null;
    _harmonyAddressSelected?: HarmonyAddress | null;
}

export interface ElectricityBillSaving {
    amount: number | null;
    frequency: SavingFrequency | null;
    pricingExplanationConfirmation: boolean | null;
}

export interface InterestFreeApplicationDetails {
    systemCost: number | null;
    deposit: number | null;
    clientName: ClientName;
    clientEmail: string;
    clientPhoneNumber: string;
    clientResidentialAddress: ClientAddress;
    systemType: string | null;
    solarPanelSize?: number;
    batterySize?: number;
    electricityBillSavings: ElectricityBillSaving;
}
export interface LinkPrefillData {
    clientEmail: string;
    clientPhoneNumber: string;
    systemCost: number;
    deposit: number;
    systemType: string;
    solarPanelSize?: string;
    batterySize?: number;
    batterySizeIndividual?: string;
    estimatedElectricityBillSavings: number;
    electricityBillSavingsFrequency: SavingFrequency;
    pricingExplanationConfirmation: boolean;
    applicantFirstName: string;
    applicantLastName: string;
    applicantMiddleName?: string;
    residentialUnitNumber?: string | null;
    residentialStreetNumber: string | null;
    residentialStreetName: string | null;
    residentialSuburb: string | null;
    residentialPostcode: string | null;
    residentialState: string | null;
    residentialFullAddress?: string | null;
    brokerEmail: string;
    renewableSubsidyApplication?: string;
    renewableRebateApplication?: string;
}
